var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px",
            inline: ""
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.areaGroupIdName"),
                        prop: "upIdList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "720px" },
                        attrs: {
                          clearable: "",
                          options: _vm.options,
                          props: _vm.propstree,
                          disabled: _vm.keyValue > 0
                        },
                        on: { change: _vm.getNode },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.buildingName"),
                        prop: "unintName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", type: "text" },
                        model: {
                          value: _vm.childData.unintName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "unintName", $$v)
                          },
                          expression: "childData.unintName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", type: "text" },
                        model: {
                          value: _vm.childData.unintOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "unintOrder", $$v)
                          },
                          expression: "childData.unintOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "720px" },
                        attrs: {
                          clearable: "",
                          maxlength: "100",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.unintRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "unintRemark", $$v)
                          },
                          expression: "childData.unintRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }